import { useContext, useEffect, useState } from "react"
import { Avatar, Box, Button, Fade, Tooltip, Typography } from "@mui/material"
import { ComputeDays, ComputePercentage, GetPercentageFormat } from "../../global/Format"
import { GetToolUsage, GetToolUsagePercentage } from "../../../global/API"
import { UsageAccessLoader } from "../../loader/Loader"
import { DirectTabLoader } from "../../loader/DirectTabLoader"
import { ToolContext } from "../../../../core/context/ToolContext"
import { rqx } from "../../../../core/request/API"
import { env } from "../../../../core/Env"
import { UserSummary } from "../userSummary/UserSummary"

export const UsageAccess = ({__SESSION, toolOwned}) => {

    const { usage_state } = useContext(ToolContext)
    const { form, graphDatasets } = usage_state

    const handleClickVisit = async(tid) => {
        // let path = {...graphDatasets.data, 
        //     aid:__SESSION.data.ainfo.aid,
        //     interval:form.data.interval.value
        // }
        // window.open(`http://localhost:3000/usage-overview?qsp=${JSON.stringify(path)}`, 'sad').focus();
        // console.log(`http://localhost:3000/usage-overview?qsp=${JSON.stringify(path)}`)
        // return
        if (tid) {
            let res = await rqx.get(`<<global>>/${env() === 'local' ? 'dev' : env()}/tools/toolcb`, {tid: tid, env:env() !== 'prod' ? 'sandbox' : 'production'});
            if (res.msg === 'success') {
                if (res.tu.length > 0) {
                    let splitStr = res.tu[0].value.split('.com/')[0]
                    let urls = splitStr+'.com' + (res.tu[0].value.includes('/biz/') ? '/biz':'')

                    let qsp = {...graphDatasets.data, 
                        aid:__SESSION.data.ainfo.aid,
                        interval:form.data.interval.value
                    }   
                    let ssoUrls = `${urls}/usage-overview?qsp=${JSON.stringify(qsp)}`
                    await DirectTabLoader(res.abbreviation+'WN', ssoUrls)
                }
            }
        }
    }

    const getUsageAccessPerTool = async(tid) => {
        let qsp = {
            company_id:__SESSION.data.uaccess[0]?.company_id,
            tool_id:tid,
            user_id:graphDatasets.data.assigned_id === 0 ? parseInt(atob(__SESSION.data.ainfo.aid).split('_', 2)[1]) : graphDatasets.data.assigned_id,
            date_from:graphDatasets.data?.start_date,
            date_to:graphDatasets.data?.last_date,
        }
       
        let res_data = await GetToolUsagePercentage(qsp)
        return res_data
        // return [
        //     {feature_id:1, feature_name:"dashboard", path:"1", count:49},
        //     {feature_id:2, feature_name:"bcloud", path:"2", count:22},
        //     {feature_id:3, feature_name:"policies", path:"3", count:30},
        //     {feature_id:4, feature_name:"general-maintenance", path:"4", count:35},
        //     {feature_id:5, feature_name:"hero", path:"5", count:40},
        //     {feature_id:6, feature_name:"tool-categories", path:"6", count:50},
        //     {feature_id:7, feature_name:"profile", path:"7", count:45},
        // ]
    }

    const getThresholdPerTool = async(tid, role_id) => {
        let qsp = {
            role_id:role_id,
            tool_id:tid,
            platform:'business'
        }
        let res = await GetToolUsage(qsp)
        return res.length > 0 ? res[0].features.map(v => { return { feature_id:v.tool_feature_id, feature_name:v.name, value:v.usage_threshold } }) : res
        // return [
        //     {feature_id:1, feature_name:"dashboard", path:"1", value:63},
        //     {feature_id:2, feature_name:"bcloud", path:"2", value:50},
        //     {feature_id:3, feature_name:"policies", path:"3", value:50},
        //     {feature_id:4, feature_name:"general-maintenance", path:"4", value:50},
        //     {feature_id:5, feature_name:"hero", path:"5", value:50},
        //     {feature_id:6, feature_name:"tool-categories", path:"6", value:50},
        //     {feature_id:7, feature_name:"profile", path:"7", value:50},
        // ]
    }

    const [usageAccess, setUsageAccess] = useState({
        average:0,
        data:[],
        loader:false
    })

    const getUsageAccess = async() => {
        setUsageAccess((prev) => ({...prev, 
            loader:true
        }))
        if (graphDatasets.data.dates.length > 0) {
            
            let res_data
            if (graphDatasets.data.assigned_id === 0 || parseInt(atob(__SESSION.data.ainfo.aid).split('_', 2)[1]) === graphDatasets.data.assigned_id) {
                res_data = toolOwned.map(v => { return { tid:v.tid, name:v.name, description:v.description, logo:v.logo, role_id:v.role_id } })
            }else{
                // THIS CODE IS FOR POFBUSINESS ONLY ADMIN OR BUSINESS OWNER
                let prms = {
                    aid:window.btoa(`account_${graphDatasets.data.assigned_id}`), 
                    platform:'business', 
                    ref:0, 
                    owner_id:__SESSION.data.uaccess[0].owner_id 
                }
                res_data = await rqx.get(`<<global>>/${env()}/tools/owned`, prms)
            }
            
            if (res_data.length > 0) {
               
                for (let i = 0; i < res_data.length; i++) {
                    let resthreshold = await getThresholdPerTool(res_data[i].tid, res_data[i].role_id)
                    let res_threshold = resthreshold.filter(f => {return f.value > 0})
                    let res_data_count = await getUsageAccessPerTool(res_data[i].tid)
                    
                    let res_compute_days = await ComputeDays(graphDatasets.data.start_date, graphDatasets.data.last_date)
    
                    const combineArray = res_threshold?.map((rt) => {
                        const rdc = res_data_count.find((rdc) => rt.feature_id === rdc.feature_id ); 
                        // const rdc = res_data_count.find((rdc) => rt.feature_id === rdc.feature_id && rt.feature_name === rdc.feature_name); 
                        return { feature_id:rt.feature_id, formula:'count / value * 100', count:rdc?.count || 0, value:(rt.value || 0) * res_compute_days, usage:rdc? ComputePercentage(rdc.count, (rt.value || 0) * res_compute_days) : 0}; 
                    });
                   
                    const averageUsage = combineArray?.reduce((sum, item) => sum + parseFloat(item.usage), 0) / combineArray?.length
                    res_data[i] = {...res_data[i], usage:GetPercentageFormat(Math.ceil(averageUsage) || 0)}
                }
                
                const totalAverageUsage = res_data?.reduce((sum, item) => sum + parseFloat(item.usage), 0) / res_data?.length
                
                if (totalAverageUsage || totalAverageUsage === 0) {
                    setUsageAccess((prev) => ({...prev, 
                        average:GetPercentageFormat(totalAverageUsage) || 0,
                        data:res_data,
                        loader:false
                    }))
                }
            }
        }
    } 

    useEffect(() => {
        getUsageAccess()
        // eslint-disable-next-line
    }, [graphDatasets.data.dates, toolOwned])
    
    return (
        <Box width="100%" height="696px" bgcolor="#FFFFFF" borderRadius="12px" p="24px">
            <Box width="100%" height="100%" display="flex" flexDirection="column" gap="16px">
                <Box minHeight="19px" display="flex" alignItems="center" gap="12px">
                    <Typography fontWeight={600} fontSize={16} lineHeight="120%" letterSpacing="-0.75%">Usage Access</Typography>
                    <Typography fontWeight={600} fontSize={16} lineHeight="120%" letterSpacing="-0.75%" color="#5DB55D">Info</Typography>
                </Box>
                {usageAccess.loader ? 
                    <UsageAccessLoader/>
                :
                    <>
                        <UserSummary graphDatasets={graphDatasets} __SESSION={__SESSION} percentage={usageAccess.average} loader={usageAccess.loader}/>
                        <Box minHeight="21px" >
                            <Typography fontWeight={600} fontSize={14} lineHeight="147%" letterSpacing="-0.75%" color="#292C2F">Tool Name</Typography>
                        </Box>
                        <Box height="100%" className="overflowY">
                            {usageAccess.data?.map((v,k) => (
                                <Box key={k} height="75px" display="flex" alignItems="center" p="16px 12px 16px 12px">
                                    <Box minWidth="256px" display="flex" alignItems="center" gap="12px">
                                        <Avatar src={JSON.parse(v.logo)} variant="square" sx={{height:'24px', width:'24px', borderRadius:'4px'}}/>
                                        <Box display="flex" flexDirection="column" gap="4">
                                            <Typography fontWeight={600} fontSize={14} lineHeight="147%" letterSpacing="0%" color="#292C2F">{v.name}</Typography>
                                            <Typography fontSize={12} fontWeight={400} lineHeight="147%" letterSpacing="-0.75%" color="#292C2F" sx={{ maxWidth:'220px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{v.description}</Typography>
                                        </Box>
                                    </Box>
                                    <Box width="100%" height="12px" bgcolor="#E7E8EA" borderRadius="100px">
                                        <Tooltip 
                                            title={v.usage} 
                                            slots={{
                                                transition: Fade,
                                            }}
                                            slotProps={{
                                                tooltip:{
                                                    sx:{backgroundColor:'#292C2F'}
                                                },
                                                arrow:{
                                                    sx:{color:'#292C2F'}
                                                },
                                                popper: {
                                                    modifiers: [{
                                                        name: 'offset',
                                                        options: {
                                                            offset: [0, -7],
                                                        },
                                                    }],
                                                },
                                            }}
                                            arrow 
                                        >
                                            <Box width={`${v.usage}%`} height="12px" bgcolor="#2F7F2F" borderRadius="100px"></Box>
                                        </Tooltip>
                                    </Box>
                                    <Button
                                        onClick={()=>handleClickVisit(v.tid)}
                                        sx={{
                                            ml:'24px',
                                            height:'39px',
                                            width:'49px',
                                            borderRadius:'4px',
                                            bgcolor:'#F7F8F8',
                                            border:'1px solid var(--Border-border-color, #E3E7EC)'
                                        }}
                                    >
                                        <Typography fontWeight={400} fontSize={12} lineHeight="142%" letterSpacing="0%" color="#292C2F">Visit</Typography>
                                    </Button>
                                </Box>
                            ))}
                        </Box>
                    </>
                }
                <Box minHeight="21px" display="flex" alignItems="center" p="16px 12px 16px 12px">
                    <Box minWidth="256px" display="flex" alignItems="center" gap="12px"></Box>
                    <Box width="100%" height="100%" display="flex" flexDirection="column" gap="6px">
                        <Box display="flex" width="100%" height="12px">
                            <Typography minWidth="25%" fontWeight={600} fontSize={12} lineHeight="120%" letterSpacing="-0.75%" color="#5B6167">0%</Typography>
                            <Typography minWidth="25%" fontWeight={600} fontSize={12} lineHeight="120%" letterSpacing="-0.75%" color="#5B6167">25%</Typography>
                            <Typography minWidth="25%"  fontWeight={600} fontSize={12} lineHeight="120%" letterSpacing="-0.75%" color="#5B6167">50%</Typography>
                            <Typography width="100%"  fontWeight={600} fontSize={12} lineHeight="120%" letterSpacing="-0.75%" color="#5B6167">75%</Typography>
                            <Typography width="100%"  fontWeight={600} fontSize={12} lineHeight="120%" letterSpacing="-0.75%" color="#5B6167" textAlign="right">100%</Typography>
                        </Box>
                    </Box>
                    <Button
                        disabled
                        sx={{
                            ml:'24px',
                            height:'39px',
                            width:'49px',
                        }}
                    ></Button>
                </Box>
                <Box minHeight="18px">
                    <Typography fontWeight={400} fontSize={12} lineHeight="147%" letterSpacing="-0.75%" color="#5B6167">Total Count {toolOwned.length}</Typography>
                </Box>
            </Box>
        </Box>

    )
}